/* KORZIVO enhancement layer. Native Shrine product and cart behavior is retained. */
(() => {
  'use strict';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const setup = (root = document) => {
    const isProduct = document.body.classList.contains('kv-product-page');
    root.querySelectorAll('[data-kv-product-link]').forEach(link => {
      if (isProduct) {
        const info = document.querySelector('.product__info-container');
        if (info && info.id) link.href = '#' + info.id;
      }
    });
    root.querySelectorAll('.kv-review-empty a').forEach(link => {
      if (link.dataset.kvBound) return;
      link.dataset.kvBound = 'true';
      link.addEventListener('click', () => {
        const section = link.closest('.kv-reviews');
        const panel = section && section.querySelector('.kv-review-form-panel');
        if (panel) panel.open = true;
      });
    });
    root.querySelectorAll('.kv-review-form').forEach(form => {
      if (form.querySelector('[role="alert"], [role="status"]')) {
        const panel = form.closest('details');
        if (panel) panel.open = true;
      }
    });
    root.querySelectorAll('.kv-menu a').forEach(link => {
      if (link.dataset.kvBound) return;
      link.dataset.kvBound = 'true';
      link.addEventListener('click', () => link.closest('details').removeAttribute('open'));
    });
    root.querySelectorAll('.kv-menu').forEach(menu => {
      if (menu.dataset.kvBound) return;
      menu.dataset.kvBound = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
      });
    });
    root.querySelectorAll('video[data-kv-loop]').forEach(video => {
      if (video.dataset.kvObserved || reducedMotion.matches || !('IntersectionObserver' in window)) return;
      video.dataset.kvObserved = 'true';
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !document.hidden && !reducedMotion.matches) {
            video.muted = true;
            const play = video.play();
            if (play) play.catch(() => {});
          } else video.pause();
        });
      }, { threshold: 0.4 });
      observer.observe(video);
    });
  };
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('video[data-kv-loop]').forEach(v => v.pause());
  });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
})();
